/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  NotificationItem,
  useDeleteNotificationMutation,
} from "../../services/notification";
import { useNavigate } from "react-router-dom";
import DeleteConfirmationModal from "../../components/DeleteModal";
import { showToast } from "../../helpers";

type NotificationsListProps = {
  fetchList?: () => void;
  notifications?: NotificationItem[];
};

const NotificationsList: React.FC<NotificationsListProps> = ({
  fetchList,
  notifications = [],
}) => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<string>("");
  const [deleteNotification] = useDeleteNotificationMutation();

  const [openDelete, setOpenDelete] = useState(false);
  const toggleDeleteModal = () => {
    setOpenDelete(!openDelete);
  };
  const handleDelete = async () => {
    try {
      await deleteNotification({ id: selectedId }).unwrap();
      fetchList?.();
      showToast("Notification deleted successfuly");
      toggleDeleteModal();
    } catch (e) {
      console.log(e);
    }
  };

  // Function to strip HTML tags from text
  const stripHtmlTags = (html: string) => {
    if (!html) return "";
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };
  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Message</TableCell>
              {/* <TableCell>Member account</TableCell> */}
              {/* <TableCell>Membership Card</TableCell> */}
              <TableCell>Schedule</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notifications.map((row, idx) => (
              <TableRow hover key={row._id || row.id || idx}>
                <TableCell>{row.title}</TableCell>
                <TableCell>{row.isBroadcast ? "Broadcast" : "Email"}</TableCell>
                <TableCell>
                  {stripHtmlTags(row.content || row.message || "-")}
                </TableCell>
                <TableCell>
                  {row.scheduleType === 2 ? "Later" : "Now"}
                </TableCell>
                <TableCell>
                  {row.createdAt
                    ? new Date(row.createdAt).toLocaleDateString()
                    : "-"}
                </TableCell>
                <TableCell>
                  <Box className="table_actions v2">
                    <IconButton
                      onClick={() =>
                        navigate(`/manage-notifications/detail/${row?._id}`)
                      }
                    >
                      <img src="/static/images/eye_icon.svg" alt="View" />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setSelectedId(row?._id || "");
                        toggleDeleteModal();
                      }}
                    >
                      <img src="/static/images/trash2_icon.svg" alt="Delete" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <DeleteConfirmationModal
        open={openDelete}
        onClose={toggleDeleteModal}
        handleDelete={handleDelete}
        header="Are you sure you want to delete this Notification?"
      />
    </>
  );
};

export default NotificationsList;
